module.exports = __webpack_public_path__ + "static/img/gd-02.85a804c4.jpg";